/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * LP account update request
 */
export interface LpAccountUpdateRequest {
  accountId: number;
  /**
   * In Nano seconds. 500_000_000 - 60_000_000_000.
   */
  maxIocOrderLifeTimeNs?: number;
}
